// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"P2-z","dimensionLabel":"Q2-z","styleChooserControlWrapper":"R2-z","styleChooserControl":"S2-z","disabled":"T2-z","giftCard":"U2-z","styleChooserText":"V2-z"};